import request from '@/utils/request'
export function imageLibraryList(data) {
    return request({
        url: '/general/imageLibrary/getList',
        method: 'post',
        data: data
    })
}
export function imageLibrarySearch(data) {
    return request({
        url: '/general/imageLibrary/search',
        method: 'post',
        data: data
    })
}
export function imageLibraryinfo(data) {
    return request({
        url: '/general/imageLibrary/info',
        method: 'post',
        data: data
    })
}

export function imageLibraryAdd(data) {
    return request({
        url: '/general/imageLibrary/add',
        method: 'post',
        data: data
    })
}
export function imageLibraryDel(data) {
    return request({
        url: '/general/imageLibrary/del',
        method: 'post',
        data: data
    })
}
export function imageLibraryUpd(data) {
    return request({
        url: '/general/imageLibrary/upd',
        method: 'post',
        data: data
    })
}